module.exports = __webpack_public_path__ + "static/img/6.6aa8786.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/12/4/1/6.png
// module id = VjXS
// module chunks = 2